import {
  CompanyOnboardingStep_Read,
  CompanyOnboardingStepKey,
  Principal_Read_Nested,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export const COMPANY_ONBOARDING_STEP_KEYS = Object.values(CompanyOnboardingStepKey);

export class CompanyOnboardingStep {
  constructor(
    private _id: string,
    private _step_key: CompanyOnboardingStepKey,
    private _completed_at: Dayjs,
    private _completed_by: Principal_Read_Nested | null = null,
  ) {}

  public static parse(proto: CompanyOnboardingStep_Read) {
    return new CompanyOnboardingStep(
      proto.id,
      proto.step_key,
      dayjs(proto.completed_at),
      proto.completed_by ?? null,
    );
  }

  public get id() {
    return this._id;
  }

  public get stepKey() {
    return this._step_key;
  }

  public get completedAt() {
    return this._completed_at;
  }

  public get completedBy() {
    return this._completed_by;
  }
}

export const summarizeCompanyOnboardingProgress = (
  completedStepsByKey: Map<CompanyOnboardingStepKey, CompanyOnboardingStep>,
) => ({
  completedCount: completedStepsByKey.size,
  currentStepKey:
    COMPANY_ONBOARDING_STEP_KEYS.find((stepKey) => !completedStepsByKey.has(stepKey)) ??
    null,
  percentComplete: Math.round(
    (100 * completedStepsByKey.size) / COMPANY_ONBOARDING_STEP_KEYS.length,
  ),
  stepKeys: COMPANY_ONBOARDING_STEP_KEYS,
  totalCount: COMPANY_ONBOARDING_STEP_KEYS.length,
});
